import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { MyTranslationSetFragmentDoc, CoverImageFragmentDoc } from '../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyTrainingPageMyTodoAssignmentsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyTrainingPageMyTodoAssignmentsCountQuery = { __typename?: 'Query', MyTodoAssignments: { __typename?: 'Assignments', totalCount: number } };

export type MyTrainingPageMyTodoAssignmentsQueryVariables = Types.Exact<{
  input: Types.MyTodoAssignmentsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type MyTrainingPageMyTodoAssignmentsQuery = { __typename?: 'Query', MyTodoAssignments: { __typename?: 'Assignments', totalCount: number, objects: Array<{ __typename?: 'Assignment', id: string, status: AssignmentStatus, attemptsCount: number, accessSources: Array<{ __typename?: 'AccessSource', id: string, createdAt: string }>, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null } | null }> } };

export type MyTrainingPageToDoAssignmentFragment = { __typename?: 'Assignment', id: string, status: AssignmentStatus, attemptsCount: number, accessSources: Array<{ __typename?: 'AccessSource', id: string, createdAt: string }>, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null } | null };

export type MyTrainingPageToDoLibraryItemFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } };

export type MyTrainingPageToDoModuleInstanceFragment = { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null };

export type MyTrainingPageToDoCourseInstanceFragment = { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null };

export type MyTrainingPageToDoScormCourseInstanceFragment = { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null };

export type MyTrainingPageCompletedAssignmentsQueryVariables = Types.Exact<{
  input: Types.AssignmentsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type MyTrainingPageCompletedAssignmentsQuery = { __typename?: 'Query', Assignments: { __typename?: 'Assignments', totalCount: number, objects: Array<{ __typename?: 'Assignment', id: string, status: AssignmentStatus, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null } | null }> } };

export type MyTrainingPageCompletedAssignmentFragment = { __typename?: 'Assignment', id: string, status: AssignmentStatus, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null } | null };

export const MyTrainingPageToDoLibraryItemFragmentDoc = gql`
    fragment MyTrainingPageToDoLibraryItem on LibraryItem {
  id
  type
  name {
    ...MyTranslationSet
  }
  coverImage {
    ...CoverImage
  }
  description {
    ...MyTranslationSet
  }
}
    ${MyTranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const MyTrainingPageToDoCourseInstanceFragmentDoc = gql`
    fragment MyTrainingPageToDoCourseInstance on CourseInstance {
  id
  track
  startedAt
  completedAt
  percentComplete
  dueDate
  certificateUrl
}
    `;
export const MyTrainingPageToDoModuleInstanceFragmentDoc = gql`
    fragment MyTrainingPageToDoModuleInstance on ModuleInstance {
  id
  startedAt
  completedAt
  percentComplete
  dueDate
}
    `;
export const MyTrainingPageToDoScormCourseInstanceFragmentDoc = gql`
    fragment MyTrainingPageToDoSCORMCourseInstance on SCORMCourseInstance {
  id
  startedAt
  completedAt
  dueDate
}
    `;
export const MyTrainingPageToDoAssignmentFragmentDoc = gql`
    fragment MyTrainingPageToDoAssignment on Assignment {
  id
  status
  attemptsCount
  accessSources {
    id
    createdAt
  }
  libraryItem {
    ...MyTrainingPageToDoLibraryItem
  }
  currentCourseInstance {
    ...MyTrainingPageToDoCourseInstance
  }
  currentModuleInstance {
    ...MyTrainingPageToDoModuleInstance
  }
  currentSCORMCourseInstance {
    ...MyTrainingPageToDoSCORMCourseInstance
  }
}
    ${MyTrainingPageToDoLibraryItemFragmentDoc}
${MyTrainingPageToDoCourseInstanceFragmentDoc}
${MyTrainingPageToDoModuleInstanceFragmentDoc}
${MyTrainingPageToDoScormCourseInstanceFragmentDoc}`;
export const MyTrainingPageCompletedAssignmentFragmentDoc = gql`
    fragment MyTrainingPageCompletedAssignment on Assignment {
  id
  status
  libraryItem {
    ...MyTrainingPageToDoLibraryItem
  }
  currentCourseInstance {
    ...MyTrainingPageToDoCourseInstance
  }
  currentModuleInstance {
    ...MyTrainingPageToDoModuleInstance
  }
  currentSCORMCourseInstance {
    ...MyTrainingPageToDoSCORMCourseInstance
  }
}
    ${MyTrainingPageToDoLibraryItemFragmentDoc}
${MyTrainingPageToDoCourseInstanceFragmentDoc}
${MyTrainingPageToDoModuleInstanceFragmentDoc}
${MyTrainingPageToDoScormCourseInstanceFragmentDoc}`;
export const MyTrainingPageMyTodoAssignmentsCountDocument = gql`
    query MyTrainingPageMyTodoAssignmentsCount {
  MyTodoAssignments {
    totalCount
  }
}
    `;

/**
 * __useMyTrainingPageMyTodoAssignmentsCountQuery__
 *
 * To run a query within a React component, call `useMyTrainingPageMyTodoAssignmentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrainingPageMyTodoAssignmentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrainingPageMyTodoAssignmentsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTrainingPageMyTodoAssignmentsCountQuery(baseOptions?: Apollo.QueryHookOptions<MyTrainingPageMyTodoAssignmentsCountQuery, MyTrainingPageMyTodoAssignmentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrainingPageMyTodoAssignmentsCountQuery, MyTrainingPageMyTodoAssignmentsCountQueryVariables>(MyTrainingPageMyTodoAssignmentsCountDocument, options);
      }
export function useMyTrainingPageMyTodoAssignmentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrainingPageMyTodoAssignmentsCountQuery, MyTrainingPageMyTodoAssignmentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrainingPageMyTodoAssignmentsCountQuery, MyTrainingPageMyTodoAssignmentsCountQueryVariables>(MyTrainingPageMyTodoAssignmentsCountDocument, options);
        }
export type MyTrainingPageMyTodoAssignmentsCountQueryHookResult = ReturnType<typeof useMyTrainingPageMyTodoAssignmentsCountQuery>;
export type MyTrainingPageMyTodoAssignmentsCountLazyQueryHookResult = ReturnType<typeof useMyTrainingPageMyTodoAssignmentsCountLazyQuery>;
export type MyTrainingPageMyTodoAssignmentsCountQueryResult = Apollo.QueryResult<MyTrainingPageMyTodoAssignmentsCountQuery, MyTrainingPageMyTodoAssignmentsCountQueryVariables>;
export const MyTrainingPageMyTodoAssignmentsDocument = gql`
    query MyTrainingPageMyTodoAssignments($input: MyTodoAssignmentsInput!, $pagination: PaginationInput) {
  MyTodoAssignments(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...MyTrainingPageToDoAssignment
    }
  }
}
    ${MyTrainingPageToDoAssignmentFragmentDoc}`;

/**
 * __useMyTrainingPageMyTodoAssignmentsQuery__
 *
 * To run a query within a React component, call `useMyTrainingPageMyTodoAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrainingPageMyTodoAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrainingPageMyTodoAssignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMyTrainingPageMyTodoAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<MyTrainingPageMyTodoAssignmentsQuery, MyTrainingPageMyTodoAssignmentsQueryVariables> & ({ variables: MyTrainingPageMyTodoAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrainingPageMyTodoAssignmentsQuery, MyTrainingPageMyTodoAssignmentsQueryVariables>(MyTrainingPageMyTodoAssignmentsDocument, options);
      }
export function useMyTrainingPageMyTodoAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrainingPageMyTodoAssignmentsQuery, MyTrainingPageMyTodoAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrainingPageMyTodoAssignmentsQuery, MyTrainingPageMyTodoAssignmentsQueryVariables>(MyTrainingPageMyTodoAssignmentsDocument, options);
        }
export type MyTrainingPageMyTodoAssignmentsQueryHookResult = ReturnType<typeof useMyTrainingPageMyTodoAssignmentsQuery>;
export type MyTrainingPageMyTodoAssignmentsLazyQueryHookResult = ReturnType<typeof useMyTrainingPageMyTodoAssignmentsLazyQuery>;
export type MyTrainingPageMyTodoAssignmentsQueryResult = Apollo.QueryResult<MyTrainingPageMyTodoAssignmentsQuery, MyTrainingPageMyTodoAssignmentsQueryVariables>;
export const MyTrainingPageCompletedAssignmentsDocument = gql`
    query MyTrainingPageCompletedAssignments($input: AssignmentsInput!, $pagination: PaginationInput) {
  Assignments(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...MyTrainingPageCompletedAssignment
    }
  }
}
    ${MyTrainingPageCompletedAssignmentFragmentDoc}`;

/**
 * __useMyTrainingPageCompletedAssignmentsQuery__
 *
 * To run a query within a React component, call `useMyTrainingPageCompletedAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrainingPageCompletedAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrainingPageCompletedAssignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMyTrainingPageCompletedAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<MyTrainingPageCompletedAssignmentsQuery, MyTrainingPageCompletedAssignmentsQueryVariables> & ({ variables: MyTrainingPageCompletedAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrainingPageCompletedAssignmentsQuery, MyTrainingPageCompletedAssignmentsQueryVariables>(MyTrainingPageCompletedAssignmentsDocument, options);
      }
export function useMyTrainingPageCompletedAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrainingPageCompletedAssignmentsQuery, MyTrainingPageCompletedAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrainingPageCompletedAssignmentsQuery, MyTrainingPageCompletedAssignmentsQueryVariables>(MyTrainingPageCompletedAssignmentsDocument, options);
        }
export type MyTrainingPageCompletedAssignmentsQueryHookResult = ReturnType<typeof useMyTrainingPageCompletedAssignmentsQuery>;
export type MyTrainingPageCompletedAssignmentsLazyQueryHookResult = ReturnType<typeof useMyTrainingPageCompletedAssignmentsLazyQuery>;
export type MyTrainingPageCompletedAssignmentsQueryResult = Apollo.QueryResult<MyTrainingPageCompletedAssignmentsQuery, MyTrainingPageCompletedAssignmentsQueryVariables>;